/* The small-input class recipe, extracted verbatim from
   components/TasksPage.jsx. The knowledge base screen and the shared directory
   picker both use it, so it cannot live inside the tasks screen. TasksPage
   re-exports it. */

export const inputCls =
  "w-full h-8 px-2.5 rounded-[8px] bg-[var(--surface-sunk)] ring-1 ring-[var(--hairline)] focus:ring-[var(--hairline-focus)] outline-none text-[13px] text-[var(--text-primary)] placeholder:text-[var(--text-quaternary)]";
